import { render } from "./UIErrorNotification.vue?vue&type=template&id=9d450792"
import script from "./UIErrorNotification.vue?vue&type=script&lang=js"
export * from "./UIErrorNotification.vue?vue&type=script&lang=js"

import "./UIErrorNotification.vue?vue&type=style&index=0&id=9d450792&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__